import { render, staticRenderFns } from "./msw-widget-card.vue?vue&type=template&id=f6537fcc&"
import script from "./msw-widget-card.vue?vue&type=script&lang=tsx&"
export * from "./msw-widget-card.vue?vue&type=script&lang=tsx&"
import style0 from "./msw-widget-card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports